import { SystemRole } from "./store/slices/authSlice";
import { IconAdvanced, IconBasic } from "./assets/svg/icon";

export const GuidEmpty = "00000000-0000-0000-0000-000000000000";

export const SYSTEM_POSITIONS_RESTAURANT_ID = {
  PartnerAdmin: 10,
  StoreAdmin: 11,
  Staff: 12,
  KitchenPart: 13,
  Accountant: 14,
  WarehouseEmployee: 15,
  PurchasingEmployee: 16,
};

export const SYSTEM_POSITIONS_RESTAURANT = [
  {
    name: "Admin thương hiệu",
    id: SYSTEM_POSITIONS_RESTAURANT_ID.PartnerAdmin,
  },
  {
    name: "Quản lý thương hiệu",
    id: SYSTEM_POSITIONS_RESTAURANT_ID.StoreAdmin,
  },
  { name: "Nhân viên", id: SYSTEM_POSITIONS_RESTAURANT_ID.Staff },
  {
    name: "Nhân viên phục vụ",
    id: SYSTEM_POSITIONS_RESTAURANT_ID.ServiceStaff,
  },
  { name: "Bộ phận bếp", id: SYSTEM_POSITIONS_RESTAURANT_ID.KitchenPart },
  { name: "Kế toán", id: SYSTEM_POSITIONS_RESTAURANT_ID.Accountant },
  {
    name: "Nhân viên kho",
    id: SYSTEM_POSITIONS_RESTAURANT_ID.WarehouseEmployee,
  },
  {
    name: "Nhân viên mua hàng",
    id: SYSTEM_POSITIONS_RESTAURANT_ID.PurchasingEmployee,
  },
];

export const SYSTEM_ROLES_RESTAURANT_ID = {
  PartnerAdmin: 10,
  StoreAdmin: 11,
  StoreEmployee: 12,
  KitchenEmployee: 13,
  AccountantEmployee: 14,
  WarehouseEmployee: 15,
  PurchasingEmployee: 16,
  EndUser: 20,
};

export const SYSTEM_ROLES_RESTAURANT = [
  { name: "Người sáng lập", id: SYSTEM_ROLES_RESTAURANT_ID.PartnerAdmin },
  { name: "Quản lý", id: SYSTEM_ROLES_RESTAURANT_ID.StoreAdmin },
  { name: "Nhân viên nhận đơn", id: SYSTEM_ROLES_RESTAURANT_ID.StoreEmployee },
  {
    name: "Nhân viên chế biến",
    id: SYSTEM_ROLES_RESTAURANT_ID.KitchenEmployee,
  },
  { name: "Kế toán", id: SYSTEM_ROLES_RESTAURANT_ID.AccountantEmployee },
  { name: "Nhân viên kho", id: SYSTEM_ROLES_RESTAURANT_ID.WarehouseEmployee },
  {
    name: "Nhân viên mua hàng",
    id: SYSTEM_ROLES_RESTAURANT_ID.PurchasingEmployee,
  },
];

export const ORDER_FILTER_TIME_ID = {
  Yesterday: 1,
  Today: 2,
  ThisWeek: 3,
  ThisMonth: 4,
  LastMonth: 5,
  CustomTime: -1,
};

export const ORDER_FILTER_TIME = [
  { value: ORDER_FILTER_TIME_ID.Yesterday, title: "Hôm qua" },
  { value: ORDER_FILTER_TIME_ID.Today, title: "Hôm nay" },
  { value: ORDER_FILTER_TIME_ID.ThisWeek, title: "Tuần này" },
  { value: ORDER_FILTER_TIME_ID.ThisMonth, title: "Tháng này" },
  { value: ORDER_FILTER_TIME_ID.LastMonth, title: "Tháng trước" },
];

export const INVOICE_STATUS = [
  { value: 0, title: "Chưa xuất HĐĐT" },
  { value: 1, title: "Đã xuất HĐĐT" },
];

export const INVOICE_TYPE = [
  { value: 0, title: "Khách lẻ không lấy hóa đơn" },
  { value: 1, title: "Khách yêu cầu lấy hóa đơn" },
];

export const PARTNER_REGISTER = "PARTNER_REGISTER";
export const PARTNER_ACTIVE = "PARTNER_ACTIVE";

export const ORDER_STATUS = [
  { value: 0, title: "Chờ xử lý", className: "ant-tag-gold", color: "#d97706" },
  {
    value: 1,
    title: "Đã xác nhận",
    className: "ant-tag-green",
    color: "#16a34a",
  },
  {
    value: 2,
    title: "Đang chế biến",
    className: "ant-tag-orange",
    color: "#ea580c",
  },
  {
    value: 3,
    title: "Chế biến xong",
    className: "ant-tag-blue",
    color: "#2563eb",
  },
  {
    value: 4,
    title: "Yêu cầu thanh toán",
    className: "ant-tag-purple",
    color: "#9333ea",
  },
  {
    value: 5,
    title: "Đã thanh toán",
    className: "ant-tag-cyan",
    color: "#059669",
  },
  {
    value: 6,
    title: "Huỷ bởi khách hàng",
    className: "ant-tag-red",
    color: "#dc2626",
  },
  {
    value: 7,
    title: "Huỷ bởi nhân viên",
    className: "ant-tag-red",
    color: "#dc2626",
  },
];

export const STATUS_PARTNER_ID = {
  Registered: 0,
  PendingApprove: 1,
  Actived: 2,
  Deactive: 3,
  Deleted: 4,
};

export const STATUS_PARTNER = [
  { value: STATUS_PARTNER_ID.Registered, title: "Chờ xác nhận" },
  { value: STATUS_PARTNER_ID.PendingApprove, title: "Chờ duyệt" },
  { value: STATUS_PARTNER_ID.Actived, title: "Đã kích hoạt" },
  { value: STATUS_PARTNER_ID.Deactive, title: "Huỷ kích hoạt" },
];

export const STATUS_PRODUCT = [
  { value: 0, title: "Ngừng kinh doanh" },
  { value: 1, title: "Đang kinh doanh" },
];

export const STATUS_ACCOUNT = [
  { value: false, title: "Hoạt động" },
  { value: true, title: "Khóa" },
];

export const GREEN_SCORE_ACCOUNT = [
  { value: true, title: "Kích hoạt tích xanh" },
  { value: false, title: "Hủy tích xanh" },
];

export const GRID_ACTION_TYPE = {
  COPY_PRODUCT: "COPY_PRODUCT",
  GROUP_CATEGORY: "GROUP_CATEGORY",
  CHANGE_STATUS_PRODUCT: "CHANGE_STATUS_PRODUCT",
  DISCOUNT_PRODUCT: "DISCOUNT_PRODUCT",
  CHANGE_PRESTIGE_PARTNER: "CHANGE_PRESTIGE_PARTNER",
  CHANGE_STATUS_ACCOUNT: "CHANGE_STATUS_ACCOUNT",
  DELETE_ACCOUNT: "DELETE_ACCOUNT",
  GREEN_SCORE_ACCOUNT: "GREEN_SCORE_ACCOUNT",
  CHANGE_GRADE_PARTNER: "CHANGE_GRADE_PARTNER",
  DELETE_MULTI_PRODUCT: "DELETE_MULTI_PRODUCT",
  OTHER_OPTION: "OTHER_OPTION",
  ADDITION_OPTION: "ADDITION_OPTION",
};

export const kgUnit = 1;
export const hUnit = 4;

export const UnitOption = [
  { value: 0, label: "đ" },
  { value: kgUnit, label: "đ/kg" },
  { value: 2, label: "đ/con" },
  { value: 3, label: "đ/suất" },
  { value: hUnit, label: "đ/giờ" },
];

export const USER_GENDER = [
  { name: "Không rõ", id: 0 },
  { name: "Nam", id: 1 },
  { name: "Nữ", id: 2 },
];

export const PARTNER_PRESTIGE = [
  { value: 0, title: "Không uy tín" },
  { value: 1, title: "Uy tín" },
];

export const ACCOUNT_TYPE = [
  { value: 20, title: "Tài khoản cá nhân" },
  { value: 10, title: "Tài khoản thương hiệu" },
];

export const STATUS_ACCOUNT_ID = {
  Actived: 0,
  Deactive: 1,
  Deleted: 2,
};

export const DELIVERY_STATUS_POST_ID = {
  Drap: 1,
  Sended: 2,
};

export const DELIVERY_STATUS_POST = [
  { value: DELIVERY_STATUS_POST_ID.Drap, title: "Bản nháp", color: "grey" },
  { value: DELIVERY_STATUS_POST_ID.Sended, title: "Đã đăng", color: "blue" },
];

export const NOTIFICATION_TYPE_ID = {
  PostCrm: 10,
};

export const STORE_TABLE_STATUS = {
  Free: 0,
  Reserved: 1,
  Cooking: 2,
  Completed: 3,
  PaymentRequest: 4,
};

export const POS_ID = {
  Table: 0,
  Order: 1,
};

export const POS = [
  { value: POS_ID.Registered, title: "Bàn" },
  { value: POS_ID.PendingApprove, title: "ĐƠn hàng" },
];

export const TABLE_ORDER_STATUS = [
  { value: 0, title: "Chờ xử lý", color: "var(--primary, #8D8D8D)" },
  { value: 1, title: "Đã xác nhận", color: "var(--primary, #219737)" },
  { value: 2, title: "Đang chế biến", color: "var(--primary, #1B78D4)" },
  { value: 3, title: "Chế biến xong", color: "var(--primary, #219737)" },
  { value: 4, title: "Yêu cầu thanh toán", color: "var(--primary, #1B78D4)" },
  { value: 5, title: "Đã thanh toán", color: "var(--primary, #219737)" },
  { value: 6, title: "Huỷ bời khách hàng", color: "var(--primary, #f5222d)" },
  { value: 7, title: "Huỷ bởi nhân viên", color: "var(--primary, #f5222d)" },
];

export const INVOICE_STATUS_ARR = [
  { value: true, label: "Đã xuất HĐĐT", color: "var(--primary, #219737)" },
  { value: false, label: "Chưa xuất HĐĐT", color: "var(--primary, #ffbf00" },
];

export const LIST_ORDER_STATUS = {
  Init: 0,
  Confirmed: 1,
  Cooking: 2,
  Completed: 3,
  PaymentRequest: 4,
  Paid: 5,
  CanceledByUser: 6,
  CanceledByAdmin: 7,
};

export const VAT = {
  VAT_CUSTOM: -3,
  NOT_VAT: -2,
  NOT_DECLARATION: -1,
};

export const VAT_LIST = [
  { value: VAT.VAT_CUSTOM, label: "Khác" },
  { value: VAT.NOT_VAT, label: "Không chịu thuế" },
  { value: VAT.NOT_DECLARATION, label: "Không kê khai" },
  { value: 0, label: "0%" },
  { value: 5, label: "5%" },
  { value: 8, label: "8%" },
  { value: 10, label: "10%" },
];

export const NotificationType = {
  OrderCreated: 0,
  OrderConfirmed: 1,
  OrderItemCooking: 2,
  OrderItemCompleted: 3,
  OrderPaymentRequested: 4,
  OrderPaid: 5,
  OrderReject: 6,
  OrderCancel: 7,
  Crm: 8,
  Promotion: 9,
};

export const CUSTOMER_CASH = 0;
export const CUSTOMER_TRANSFER = 1;
export const CUSTOMER_GRAB_PAY = 2;
export const CUSTOMER_VN_PAY = 6;
export const CUSTOMER_G_PAY = 7;
export const CUSTOMER_SDK_G_PAY = 8;
export const CUSTOMER_SHOPEE_PAY = 3;
export const CUSTOMER_SM = 4;
export const CUSTOMER_OTHER = 5;
export const CUSTOMER_PROMOTION = 9;
export const PAYMENT_METHOD = [
  { label: "Tiền mặt", value: CUSTOMER_CASH },
  { label: "Chuyển khoản", value: CUSTOMER_TRANSFER },
  { label: "Grabpay", value: CUSTOMER_GRAB_PAY },
  { label: "Shopeepay", value: CUSTOMER_SHOPEE_PAY },
  { label: "XanhSM", value: CUSTOMER_SM },
  { label: "Khác", value: CUSTOMER_OTHER },
  { label: "Vnpay", value: CUSTOMER_VN_PAY },
  { label: "Galaxy Pay", value: CUSTOMER_G_PAY },
  { label: "SoftPos", value: CUSTOMER_SDK_G_PAY },
  { label: "Ưu đãi", value: CUSTOMER_PROMOTION },
];

export const GROUP_ORDER = 0;
export const EXTRACT_ORDER = 1;
export const CHANGE_TABLE = 2;
export const GROUP_TABLE = 3;
export const ADD_ITEM_EXTERNAL = 4;
export const SETTING_ORDER = 5;
export const CANCE_ORDER_PAID = 6;
export const EDIT_ORDER_PAID = 7;
export const REQUEST_INVOICE = 8;
export const CAL_VAT = "CAL_VAT";
export const DISPLAY_VAT = "DISPLAY_VAT";
export const SERVICE_CHARGE = "SERVICE_CHARGE";
export const SERVICE_DELIVERY = "SERVICE_DELIVERY";
export const PRE_PAYMENT = "PRE_PAYMENT";
export const TYPE_ORDER = "TYPE_ORDER";
export const EAT_TABLE = "EAT_TABLE";
export const BRING_BACK = "BRING_BACK";
export const DELIVERY = "DELIVERY";
export const CAL_DISCOUNT = "CAL_DISCOUNT";
export const USE_REWARD = "USE_REWARD";
export const USE_VOUCHER = "USE_VOUCHER";
export const OPTIMAL_PROCESS = "OPTIMAL_PROCESS";
export const BASIC_PROCESS = "BASIC_PROCESS";
export const COMPLETE_PROCESS = "COMPLETE_PROCESS";
export const RELEASE_PURCHASING = "RELEASE_PURCHASING";
export const REQUEST_PURCHASING = "REQUEST_PURCHASING";

export const initOrderSetting = {
  displayDetail: [
    CAL_VAT,
    DISPLAY_VAT,
    PRE_PAYMENT,
    SERVICE_CHARGE,
    SERVICE_DELIVERY,
  ],
  type: EAT_TABLE,
};

export const ORDER_TYPES = [
  { value: EAT_TABLE, title: "Tại quán" },
  { value: BRING_BACK, title: "Mang về" },
  { value: DELIVERY, title: "Giao hàng" },
];

export const ORDER_DISPLAY = [
  { value: CAL_VAT, title: "order.cal_vat", subTitle: "order.cal_vat_sub" },
  {
    value: DISPLAY_VAT,
    title: "order.display_vat",
    subTitle: "order.display_vat_sub",
  },
  {
    value: CAL_DISCOUNT,
    title: "order.cal_discount",
    subTitle: "order.cal_discount_sub",
  },
  {
    value: SERVICE_CHARGE,
    title: "order.service_charge",
    subTitle: "order.service_charge_sub",
  },
  {
    value: SERVICE_DELIVERY,
    title: "order.service_delivery",
    subTitle: "order.service_delivery_sub",
  },
  {
    value: PRE_PAYMENT,
    title: "order.pre_payment",
    subTitle: "order.pre_payment_sub",
  },
  {
    value: TYPE_ORDER,
    title: "order.type_order",
    subTitle: "order.type_order_sub",
  },
];

export const OPTION_PRESTIGE = [
  { value: 101, label: "Uy tín" },
  { value: 102, label: "Không uy tín" },
];

export const OPTION_STAR = [
  { value: 201, label: "1 sao" },
  { value: 202, label: "2 sao" },
  { value: 203, label: "3 sao" },
  { value: 204, label: "4 sao" },
  { value: 205, label: "5 sao" },
  { value: 206, label: "6 sao" },
  { value: 207, label: "7 sao" },
];

export const OPTION_MICHELIN = [
  { value: 300, label: "Michelin Guide" },
  { value: 301, label: "Michelin 1" },
  { value: 302, label: "Michelin 2" },
  { value: 303, label: "Michelin 3" },
];

export const DEFAULT_GROUP = "Khác";

export const MENU_LIST = "MENU_LIST";
export const MENU_GRID = "MENU_GRID";

export const VIETTEL_INVOICE = 1;
export const MISA_INVOICE = 2;
export const PARTNER_INVOICE = [
  { value: VIETTEL_INVOICE, label: "SInvoice" },
  { value: MISA_INVOICE, label: 'MeInvoice' },
];

export const TYPE_INPUT_PRICE = [
  { value: "percent", label: "Nhập phần trăm" },
  { value: "price", label: "Nhập số tiền" },
];

export const MODULE_SUBSCRIPTION = [
  { value: "MANAGE_POINT", label: "Quản lý khuyến mãi" },
  { value: "MANAGE_WAREHOUSE", label: "Quản lý kho hàng" },
  { value: "MANAGE_INVOICE", label: "Xuất hóa đơn MTT" },
];

export const INVOICE_ERROR_CODE = {
  INVOICE_HAS_CODE_NOT_SENT: "INVOICE_HAS_CODE_NOT_SENT",
  INVOICE_HAS_CODE_DIS_APPROVED: "INVOICE_HAS_CODE_DIS_APPROVED",
};

export const SUBSCRIPTION = {
  Free: 1,
  Basic: 2,
  Advance: 3,
};

export const SUBSCRIPTION_ICON = [
  {
    value: SUBSCRIPTION.Basic,
    colorBorder: "#81D88F",
    icon: <IconBasic size={18} />,
  },
  {
    value: SUBSCRIPTION.Advance,
    colorBorder: "#7AA2FE",
    icon: <IconAdvanced size={18} />,
  },
];

export const STATUS_SUSCRIPTION = [
  { value: false, label: "Hủy kích hoạt", color: "#f50" },
  { value: true, label: "Đã kích hoạt", color: "#87d068" },
];

export const SUBSCRIPTION_TYPE_ID = {
  PurchaseSubscription: 0,
  ExtendSubscription: 1,
  UpgradeSubscription: 2,
  ActiveSubscription: 3,
};

export const SubscriptionType = [
  {
    value: SUBSCRIPTION_TYPE_ID.PurchaseSubscription,
    label: "Mua mới",
    color: "green",
  },
  {
    value: SUBSCRIPTION_TYPE_ID.ExtendSubscription,
    label: "Gia hạn",
    color: "orange",
  },
  {
    value: SUBSCRIPTION_TYPE_ID.UpgradeSubscription,
    label: "Nâng cấp",
    color: "blue",
  },
  {
    value: SUBSCRIPTION_TYPE_ID.ActiveSubscription,
    label: "Kích hoạt",
    color: "pink",
  },
];

export const CREATED_ROLE = [
  { value: SystemRole.OperatorAdmin, label: "Quản trị hệ thống" },
  { value: SystemRole.PartnerAdmin, label: "Người sáng lập" },
];

export const RATING_CATEGORY = {
  RATING_IMPROVE: 0,
  RATING_GOOD: 1,
};

export const ReportViolationStatus = {
  PENDING: 0,
  PENDING_UPDATE: 1,
  UPDATED: 2,
  COMPLAINT: 3,
  PROCESSED: 4,
  NO_VIOLATION: 5,
};

export const REPORT_VIOLATION_LIST = [
  {
    value: ReportViolationStatus.PENDING,
    description: "Chờ xác nhận",
    badge: "processing",
  },
  {
    value: ReportViolationStatus.PENDING_UPDATE,
    description: "Chờ cập nhật",
    badge: "processing",
  },
  {
    value: ReportViolationStatus.UPDATED,
    description: "Đã cập nhật",
    badge: "success",
  },
  {
    value: ReportViolationStatus.COMPLAINT,
    description: "Khiếu nại",
    badge: "warning",
  },
  {
    value: ReportViolationStatus.PROCESSED,
    description: "Đã xử lý",
    badge: "error",
  },
  {
    value: ReportViolationStatus.NO_VIOLATION,
    description: "Không vi phạm",
    badge: "success",
  },
];

export const ReportViolationEnum = {
  STORE: 1,
  USER: 2,
  POST: 3,
  COMMENT: 4,
  PRODUCT: 5,
};

export const AFFILIATE_SETTING = {
  PERSONAL_AFFILIATE: 0,
  AGENCY_AFFILIATE: 1,
  UNDER_AGENCY_AFFILIATE: 2,
};

export const GoogleCategories = [
  {
    name: "categories/gcid:cafe",
    displayName: "Quán cà phê",
  },
  {
    name: "categories/gcid:hotel",
    displayName: "Khách sạn",
  },
  {
    name: "categories/gcid:restaurant",
    displayName: "Nhà hàng",
  },
  {
    name: "categories/gcid:store",
    displayName: "Cửa hàng",
  },
  {
    name: "categories/gcid:grocery_store",
    displayName: "Cửa hàng tạp hóa",
  },
  {
    name: "categories/gcid:kiosk",
    displayName: "Ki ốt",
  },
  {
    name: "categories/gcid:tea_house",
    displayName: "Phòng trà",
  },
  {
    name: "categories/gcid:fast_food_restaurant",
    displayName: "Nhà hàng ăn nhanh",
  },
  {
    name: "categories/gcid:villa",
    displayName: "Biệt thự",
  },
  {
    name: "categories/gcid:resort_hotel",
    displayName: "Khách sạn nghỉ dưỡng",
  },
  {
    name: "categories/gcid:karaoke",
    displayName: "Karaoke",
  },
  {
    name: "categories/gcid:medical_clinic",
    displayName: "Phòng khám",
  },
  {
    name: "categories/gcid:spa",
    displayName: "Spa",
  },
  {
    name: "categories/gcid:playground",
    displayName: "Sân chơi",
  },
  {
    name: "categories/gcid:motel",
    displayName: "Nhà trọ",
  },
  {
    name: "categories/gcid:car_leasing_service",
    displayName: "Dịch vụ cho thuê ô tô",
  },
  {
    name: "categories/gcid:guest_house",
    displayName: "Nhà nghỉ",
  },
  {
    name: "categories/gcid:dental_clinic",
    displayName: "Phòng khám nha khoa",
  },
  {
    name: "categories/gcid:soft_drinks_shop",
    displayName: "Cửa hàng đồ uống",
  },
  {
    name: "categories/gcid:school",
    displayName: "Trường học",
  },
  {
    name: "categories/gcid:sports_club",
    displayName: "Câu lạc bộ thể thao",
  },
  {
    name: "categories/gcid:shopping_center",
    displayName: "Trung tâm mua sắm",
  },
  {
    name: "categories/gcid:laundry_service",
    displayName: "Dịch vụ giặt ủi",
  },
  {
    name: "categories/gcid:tour_agency",
    displayName: "Đại lý du lịch",
  },
  {
    name: "categories/gcid:barber_shop",
    displayName: "Tiệm cắt tóc",
  },
  {
    name: "categories/gcid:tourist_attraction",
    displayName: "Điểm thu hút khách du lịch",
  },
  {
    name: "categories/gcid:beauty_salon",
    displayName: "Thẩm mỹ viện",
  },
  {
    name: "categories/gcid:private_guest_room",
    displayName: "Lưu trú nhà dân",
  },
  {
    name: "categories/gcid:association_or_organization",
    displayName: "Hiệp hội/Tổ chức",
  },
  {
    name: "categories/gcid:bank",
    displayName: "Ngân hàng",
  },
];

export const AI_TYPE = [
  { id: "GEMINI_GOOGLE", label: "Gemini" },
  { id: "CHAT_GPT", label: "Chat GPT" },
];

export const AI_MODEL = [
  {
    id: "gpt-4o-mini-transcribe",
    object: "model",
    created: 1742068596,
    owned_by: "system",
  },
  {
    id: "gpt-4o-audio-preview-2024-12-17",
    object: "model",
    created: 1734034239,
    owned_by: "system",
  },
  {
    id: "dall-e-3",
    object: "model",
    created: 1698785189,
    owned_by: "system",
  },
  {
    id: "dall-e-2",
    object: "model",
    created: 1698798177,
    owned_by: "system",
  },
  {
    id: "gpt-4o-audio-preview-2024-10-01",
    object: "model",
    created: 1727389042,
    owned_by: "system",
  },
  {
    id: "o1-mini-2024-09-12",
    object: "model",
    created: 1725648979,
    owned_by: "system",
  },
  {
    id: "omni-moderation-latest",
    object: "model",
    created: 1731689265,
    owned_by: "system",
  },
  {
    id: "omni-moderation-2024-09-26",
    object: "model",
    created: 1732734466,
    owned_by: "system",
  },
  {
    id: "gpt-4o-realtime-preview-2024-10-01",
    object: "model",
    created: 1727131766,
    owned_by: "system",
  },
  {
    id: "babbage-002",
    object: "model",
    created: 1692634615,
    owned_by: "system",
  },
  {
    id: "o1-mini",
    object: "model",
    created: 1725649008,
    owned_by: "system",
  },
  {
    id: "tts-1-hd-1106",
    object: "model",
    created: 1699053533,
    owned_by: "system",
  },
  {
    id: "text-embedding-3-large",
    object: "model",
    created: 1705953180,
    owned_by: "system",
  },
  {
    id: "gpt-4",
    object: "model",
    created: 1687882411,
    owned_by: "openai",
  },
  {
    id: "gpt-4o-mini-2024-07-18",
    object: "model",
    created: 1721172717,
    owned_by: "system",
  },
  {
    id: "gpt-4o-2024-05-13",
    object: "model",
    created: 1715368132,
    owned_by: "system",
  },
  {
    id: "gpt-4o-realtime-preview-2024-12-17",
    object: "model",
    created: 1733945430,
    owned_by: "system",
  },
  {
    id: "tts-1-hd",
    object: "model",
    created: 1699046015,
    owned_by: "system",
  },
  {
    id: "gpt-4o-mini-audio-preview",
    object: "model",
    created: 1734387424,
    owned_by: "system",
  },
  {
    id: "gpt-4o-audio-preview",
    object: "model",
    created: 1727460443,
    owned_by: "system",
  },
  {
    id: "o1-preview-2024-09-12",
    object: "model",
    created: 1725648865,
    owned_by: "system",
  },
  {
    id: "gpt-4o-realtime-preview",
    object: "model",
    created: 1727659998,
    owned_by: "system",
  },
  {
    id: "gpt-3.5-turbo-instruct-0914",
    object: "model",
    created: 1694122472,
    owned_by: "system",
  },
  {
    id: "gpt-4o-mini-search-preview",
    object: "model",
    created: 1741391161,
    owned_by: "system",
  },
  {
    id: "tts-1-1106",
    object: "model",
    created: 1699053241,
    owned_by: "system",
  },
  {
    id: "davinci-002",
    object: "model",
    created: 1692634301,
    owned_by: "system",
  },
  {
    id: "gpt-3.5-turbo-1106",
    object: "model",
    created: 1698959748,
    owned_by: "system",
  },
  {
    id: "gpt-4o-search-preview",
    object: "model",
    created: 1741388720,
    owned_by: "system",
  },
  {
    id: "gpt-4-turbo",
    object: "model",
    created: 1712361441,
    owned_by: "system",
  },
  {
    id: "gpt-3.5-turbo-instruct",
    object: "model",
    created: 1692901427,
    owned_by: "system",
  },
  {
    id: "gpt-3.5-turbo",
    object: "model",
    created: 1677610602,
    owned_by: "openai",
  },
  {
    id: "gpt-4-turbo-preview",
    object: "model",
    created: 1706037777,
    owned_by: "system",
  },
  {
    id: "gpt-4o-mini-search-preview-2025-03-11",
    object: "model",
    created: 1741390858,
    owned_by: "system",
  },
  {
    id: "gpt-4o-mini-realtime-preview",
    object: "model",
    created: 1734387380,
    owned_by: "system",
  },
  {
    id: "chatgpt-4o-latest",
    object: "model",
    created: 1723515131,
    owned_by: "system",
  },
  {
    id: "whisper-1",
    object: "model",
    created: 1677532384,
    owned_by: "openai-internal",
  },
  {
    id: "gpt-3.5-turbo-0125",
    object: "model",
    created: 1706048358,
    owned_by: "system",
  },
  {
    id: "gpt-4-turbo-2024-04-09",
    object: "model",
    created: 1712601677,
    owned_by: "system",
  },
  {
    id: "gpt-3.5-turbo-16k",
    object: "model",
    created: 1683758102,
    owned_by: "openai-internal",
  },
  {
    id: "gpt-4o",
    object: "model",
    created: 1715367049,
    owned_by: "system",
  },
  {
    id: "gpt-4o-mini-realtime-preview-2024-12-17",
    object: "model",
    created: 1734112601,
    owned_by: "system",
  },
  {
    id: "gpt-4-1106-preview",
    object: "model",
    created: 1698957206,
    owned_by: "system",
  },
  {
    id: "text-embedding-ada-002",
    object: "model",
    created: 1671217299,
    owned_by: "openai-internal",
  },
  {
    id: "o1-preview",
    object: "model",
    created: 1725648897,
    owned_by: "system",
  },
  {
    id: "gpt-4-0613",
    object: "model",
    created: 1686588896,
    owned_by: "openai",
  },
  {
    id: "gpt-4.5-preview",
    object: "model",
    created: 1740623059,
    owned_by: "system",
  },
  {
    id: "gpt-4.5-preview-2025-02-27",
    object: "model",
    created: 1740623304,
    owned_by: "system",
  },
  {
    id: "gpt-4o-search-preview-2025-03-11",
    object: "model",
    created: 1741388170,
    owned_by: "system",
  },
  {
    id: "gpt-4o-2024-11-20",
    object: "model",
    created: 1739331543,
    owned_by: "system",
  },
  {
    id: "tts-1",
    object: "model",
    created: 1681940951,
    owned_by: "openai-internal",
  },
  {
    id: "gpt-4o-mini-tts",
    object: "model",
    created: 1742403959,
    owned_by: "system",
  },
  {
    id: "text-embedding-3-small",
    object: "model",
    created: 1705948997,
    owned_by: "system",
  },
  {
    id: "gpt-4-0125-preview",
    object: "model",
    created: 1706037612,
    owned_by: "system",
  },
  {
    id: "gpt-4o-transcribe",
    object: "model",
    created: 1742068463,
    owned_by: "system",
  },
  {
    id: "gpt-4o-mini",
    object: "model",
    created: 1721172741,
    owned_by: "system",
  },
  {
    id: "gpt-4o-2024-08-06",
    object: "model",
    created: 1722814719,
    owned_by: "system",
  },
  {
    id: "gpt-4o-mini-audio-preview-2024-12-17",
    object: "model",
    created: 1734115920,
    owned_by: "system",
  },
];

export const AI_GEMINI_MODEL = [
  {
    name: "gemini-2.5-flash",
    version: "001",
    displayName: "Gemini 2.5 Flash",
    description:
      "Stable version of Gemini 2.5 Flash, our mid-size multimodal model that supports up to 1 million tokens, released in June of 2025.",
    inputTokenLimit: 1048576,
    outputTokenLimit: 65536,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "createCachedContent",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "gemini-2.5-pro",
    version: "2.5",
    displayName: "Gemini 2.5 Pro",
    description: "Stable release (June 17th, 2025) of Gemini 2.5 Pro",
    inputTokenLimit: 1048576,
    outputTokenLimit: 65536,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "createCachedContent",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "gemini-2.0-flash",
    version: "2.0",
    displayName: "Gemini 2.0 Flash",
    description: "Gemini 2.0 Flash",
    inputTokenLimit: 1048576,
    outputTokenLimit: 8192,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "createCachedContent",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 40,
    maxTemperature: 2,
  },
  {
    name: "gemini-2.0-flash-001",
    version: "2.0",
    displayName: "Gemini 2.0 Flash 001",
    description:
      "Stable version of Gemini 2.0 Flash, our fast and versatile multimodal model for scaling across diverse tasks, released in January of 2025.",
    inputTokenLimit: 1048576,
    outputTokenLimit: 8192,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "createCachedContent",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 40,
    maxTemperature: 2,
  },
  {
    name: "gemini-2.0-flash-lite-001",
    version: "2.0",
    displayName: "Gemini 2.0 Flash-Lite 001",
    description: "Stable version of Gemini 2.0 Flash-Lite",
    inputTokenLimit: 1048576,
    outputTokenLimit: 8192,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "createCachedContent",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 40,
    maxTemperature: 2,
  },
  {
    name: "gemini-2.0-flash-lite",
    version: "2.0",
    displayName: "Gemini 2.0 Flash-Lite",
    description: "Gemini 2.0 Flash-Lite",
    inputTokenLimit: 1048576,
    outputTokenLimit: 8192,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "createCachedContent",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 40,
    maxTemperature: 2,
  },
  {
    name: "gemini-2.5-flash-preview-tts",
    version: "gemini-2.5-flash-exp-tts-2025-05-19",
    displayName: "Gemini 2.5 Flash Preview TTS",
    description: "Gemini 2.5 Flash Preview TTS",
    inputTokenLimit: 8192,
    outputTokenLimit: 16384,
    supportedGenerationMethods: ["countTokens", "generateContent"],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
  },
  {
    name: "gemini-2.5-pro-preview-tts",
    version: "gemini-2.5-pro-preview-tts-2025-05-19",
    displayName: "Gemini 2.5 Pro Preview TTS",
    description: "Gemini 2.5 Pro Preview TTS",
    inputTokenLimit: 8192,
    outputTokenLimit: 16384,
    supportedGenerationMethods: [
      "countTokens",
      "generateContent",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
  },
  {
    name: "gemma-4-26b-a4b-it",
    version: "001",
    displayName: "Gemma 4 26B A4B IT",
    description: "Gemma 4 26B A4B IT",
    inputTokenLimit: 262144,
    outputTokenLimit: 32768,
    supportedGenerationMethods: ["generateContent", "countTokens"],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "gemma-4-31b-it",
    version: "001",
    displayName: "Gemma 4 31B IT",
    description: "Gemma 4 31B IT",
    inputTokenLimit: 262144,
    outputTokenLimit: 32768,
    supportedGenerationMethods: ["generateContent", "countTokens"],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "gemini-flash-latest",
    version: "Gemini Flash Latest",
    displayName: "Gemini Flash Latest",
    description: "Latest release of Gemini Flash",
    inputTokenLimit: 1048576,
    outputTokenLimit: 65536,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "createCachedContent",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "gemini-flash-lite-latest",
    version: "Gemini Flash-Lite Latest",
    displayName: "Gemini Flash-Lite Latest",
    description: "Latest release of Gemini Flash-Lite",
    inputTokenLimit: 1048576,
    outputTokenLimit: 65536,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "createCachedContent",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "gemini-pro-latest",
    version: "Gemini Pro Latest",
    displayName: "Gemini Pro Latest",
    description: "Latest release of Gemini Pro",
    inputTokenLimit: 1048576,
    outputTokenLimit: 65536,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "createCachedContent",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "gemini-2.5-flash-lite",
    version: "001",
    displayName: "Gemini 2.5 Flash-Lite",
    description:
      "Stable version of Gemini 2.5 Flash-Lite, released in July of 2025",
    inputTokenLimit: 1048576,
    outputTokenLimit: 65536,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "createCachedContent",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "gemini-2.5-flash-image",
    version: "2.0",
    displayName: "Nano Banana",
    description: "Gemini 2.5 Flash Preview Image",
    inputTokenLimit: 32768,
    outputTokenLimit: 32768,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 1,
  },
  {
    name: "gemini-3-pro-preview",
    version: "3-pro-preview-11-2025",
    displayName: "Gemini 3 Pro Preview",
    description: "Gemini 3 Pro Preview",
    inputTokenLimit: 1048576,
    outputTokenLimit: 65536,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "createCachedContent",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "gemini-3-flash-preview",
    version: "3-flash-preview-12-2025",
    displayName: "Gemini 3 Flash Preview",
    description: "Gemini 3 Flash Preview",
    inputTokenLimit: 1048576,
    outputTokenLimit: 65536,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "createCachedContent",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "gemini-3.1-pro-preview",
    version: "3.1-pro-preview-01-2026",
    displayName: "Gemini 3.1 Pro Preview",
    description: "Gemini 3.1 Pro Preview",
    inputTokenLimit: 1048576,
    outputTokenLimit: 65536,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "createCachedContent",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "gemini-3.1-pro-preview-customtools",
    version: "3.1-pro-preview-01-2026",
    displayName: "Gemini 3.1 Pro Preview Custom Tools",
    description: "Gemini 3.1 Pro Preview optimized for custom tool usage",
    inputTokenLimit: 1048576,
    outputTokenLimit: 65536,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "createCachedContent",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "gemini-3.1-flash-lite-preview",
    version: "3.1-flash-lite-preview-03-2026",
    displayName: "Gemini 3.1 Flash Lite Preview",
    description: "Gemini 3.1 Flash Lite Preview",
    inputTokenLimit: 1048576,
    outputTokenLimit: 65536,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "createCachedContent",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "gemini-3.1-flash-lite",
    version: "3.1-flash-lite-05-2026",
    displayName: "Gemini 3.1 Flash Lite",
    description: "Gemini 3.1 Flash Lite",
    inputTokenLimit: 1048576,
    outputTokenLimit: 65536,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "createCachedContent",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "gemini-3-pro-image-preview",
    version: "3.0",
    displayName: "Nano Banana Pro",
    description: "Gemini 3 Pro Image Preview",
    inputTokenLimit: 131072,
    outputTokenLimit: 32768,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 1,
    thinking: true,
  },
  {
    name: "gemini-3-pro-image",
    version: "3.0",
    displayName: "Nano Banana Pro",
    description: "Gemini 3 Pro Image",
    inputTokenLimit: 131072,
    outputTokenLimit: 32768,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 1,
    thinking: true,
  },
  {
    name: "nano-banana-pro-preview",
    version: "3.0",
    displayName: "Nano Banana Pro",
    description: "Gemini 3 Pro Image Preview",
    inputTokenLimit: 131072,
    outputTokenLimit: 32768,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 1,
    thinking: true,
  },
  {
    name: "gemini-3.1-flash-image-preview",
    version: "3.0",
    displayName: "Nano Banana 2",
    description: "Gemini 3.1 Flash Image Preview.",
    inputTokenLimit: 65536,
    outputTokenLimit: 65536,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 1,
    thinking: true,
  },
  {
    name: "gemini-3.1-flash-image",
    version: "3.0",
    displayName: "Nano Banana 2",
    description: "Gemini 3.1 Flash Image.",
    inputTokenLimit: 65536,
    outputTokenLimit: 65536,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 1,
    thinking: true,
  },
  {
    name: "gemini-3.5-flash",
    version: "3.5-flash-05-2026",
    displayName: "Gemini 3.5 Flash",
    description: "Gemini 3.5 Flash",
    inputTokenLimit: 1048576,
    outputTokenLimit: 65536,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "createCachedContent",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "lyria-3-clip-preview",
    version: "lyria-3-clip-preview",
    displayName: "Lyria 3 Clip Preview",
    description: "Lyria 3 30s model Preview",
    inputTokenLimit: 1048576,
    outputTokenLimit: 65536,
    supportedGenerationMethods: ["generateContent", "countTokens"],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
  },
  {
    name: "lyria-3-pro-preview",
    version: "lyria-3-pro-preview",
    displayName: "Lyria 3 Pro Preview",
    description: "Lyria 3 Pro Preview",
    inputTokenLimit: 1048576,
    outputTokenLimit: 65536,
    supportedGenerationMethods: ["generateContent", "countTokens"],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
  },
  {
    name: "gemini-3.1-flash-tts-preview",
    version: "3.1-flash-tts-preview",
    displayName: "Gemini 3.1 Flash TTS Preview",
    description: "Gemini 3.1 Flash TTS Preview",
    inputTokenLimit: 8192,
    outputTokenLimit: 16384,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "gemini-robotics-er-1.5-preview",
    version: "1.5-preview",
    displayName: "Gemini Robotics-ER 1.5 Preview",
    description: "Gemini Robotics-ER 1.5 Preview",
    inputTokenLimit: 1048576,
    outputTokenLimit: 65536,
    supportedGenerationMethods: ["generateContent", "countTokens"],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "gemini-robotics-er-1.6-preview",
    version: "1.6-preview",
    displayName: "Gemini Robotics-ER 1.6 Preview",
    description: "Gemini Robotics-ER 1.6 Preview",
    inputTokenLimit: 131072,
    outputTokenLimit: 65536,
    supportedGenerationMethods: [
      "generateContent",
      "countTokens",
      "createCachedContent",
      "batchGenerateContent",
    ],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "gemini-2.5-computer-use-preview-10-2025",
    version: "Gemini 2.5 Computer Use Preview 10-2025",
    displayName: "Gemini 2.5 Computer Use Preview 10-2025",
    description: "Gemini 2.5 Computer Use Preview 10-2025",
    inputTokenLimit: 131072,
    outputTokenLimit: 65536,
    supportedGenerationMethods: ["generateContent", "countTokens"],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "antigravity-preview-05-2026",
    version: "0.1",
    displayName: "Antigravity Agent Preview",
    description: "Preview release of Antigravity Agent (05-2026)",
    inputTokenLimit: 131072,
    outputTokenLimit: 65536,
    supportedGenerationMethods: ["generateContent", "countTokens"],
  },
  {
    name: "deep-research-max-preview-04-2026",
    version: "deepthink-exp-05-20",
    displayName: "Deep Research Max Preview (Apr-21-2026)",
    description: "Preview release (April 21st, 2026) of Deep Research Max",
    inputTokenLimit: 131072,
    outputTokenLimit: 65536,
    supportedGenerationMethods: ["generateContent", "countTokens"],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "deep-research-preview-04-2026",
    version: "deepthink-exp-05-20",
    displayName: "Deep Research Preview (Apr-21-2026)",
    description: "Preview release (April 21th, 2026) of Deep Research",
    inputTokenLimit: 131072,
    outputTokenLimit: 65536,
    supportedGenerationMethods: ["generateContent", "countTokens"],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "deep-research-pro-preview-12-2025",
    version: "deepthink-exp-05-20",
    displayName: "Deep Research Pro Preview (Dec-12-2025)",
    description: "Preview release (December 12th, 2025) of Deep Research Pro",
    inputTokenLimit: 131072,
    outputTokenLimit: 65536,
    supportedGenerationMethods: ["generateContent", "countTokens"],
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxTemperature: 2,
    thinking: true,
  },
  {
    name: "gemini-embedding-001",
    version: "001",
    displayName: "Gemini Embedding 001",
    description: "Obtain a distributed representation of a text.",
    inputTokenLimit: 2048,
    outputTokenLimit: 1,
    supportedGenerationMethods: [
      "embedContent",
      "countTextTokens",
      "countTokens",
      "asyncBatchEmbedContent",
    ],
  },
  {
    name: "gemini-embedding-2-preview",
    version: "2",
    displayName: "Gemini Embedding 2 Preview",
    description: "Obtain a distributed representation of multimodal content.",
    inputTokenLimit: 8192,
    outputTokenLimit: 1,
    supportedGenerationMethods: [
      "embedContent",
      "countTextTokens",
      "countTokens",
      "asyncBatchEmbedContent",
    ],
  },
  {
    name: "gemini-embedding-2",
    version: "2",
    displayName: "Gemini Embedding 2",
    description: "Obtain a distributed representation of multimodal content.",
    inputTokenLimit: 8192,
    outputTokenLimit: 1,
    supportedGenerationMethods: [
      "embedContent",
      "countTextTokens",
      "countTokens",
      "asyncBatchEmbedContent",
    ],
  },
  {
    name: "aqa",
    version: "001",
    displayName: "Model that performs Attributed Question Answering.",
    description:
      "Model trained to return answers to questions that are grounded in provided sources, along with estimating answerable probability.",
    inputTokenLimit: 7168,
    outputTokenLimit: 1024,
    supportedGenerationMethods: ["generateAnswer"],
    temperature: 0.2,
    topP: 1,
    topK: 40,
  },
  {
    name: "imagen-4.0-generate-001",
    version: "001",
    displayName: "Imagen 4",
    description: "Vertex served Imagen 4.0 model",
    inputTokenLimit: 480,
    outputTokenLimit: 8192,
    supportedGenerationMethods: ["predict"],
  },
  {
    name: "imagen-4.0-ultra-generate-001",
    version: "001",
    displayName: "Imagen 4 Ultra",
    description: "Vertex served Imagen 4.0 ultra model",
    inputTokenLimit: 480,
    outputTokenLimit: 8192,
    supportedGenerationMethods: ["predict"],
  },
  {
    name: "imagen-4.0-fast-generate-001",
    version: "001",
    displayName: "Imagen 4 Fast",
    description: "Vertex served Imagen 4.0 Fast model",
    inputTokenLimit: 480,
    outputTokenLimit: 8192,
    supportedGenerationMethods: ["predict"],
  },
  {
    name: "veo-2.0-generate-001",
    version: "2.0",
    displayName: "Veo 2",
    description:
      "Vertex served Veo 2 model. Access to this model requires billing to be enabled on the associated Google Cloud Platform account. Please visit https://console.cloud.google.com/billing to enable it.",
    inputTokenLimit: 480,
    outputTokenLimit: 8192,
    supportedGenerationMethods: ["predictLongRunning"],
  },
  {
    name: "veo-3.0-generate-001",
    version: "3.0",
    displayName: "Veo 3",
    description: "Veo 3",
    inputTokenLimit: 480,
    outputTokenLimit: 8192,
    supportedGenerationMethods: ["predictLongRunning"],
  },
  {
    name: "veo-3.0-fast-generate-001",
    version: "3.0",
    displayName: "Veo 3 fast",
    description: "Veo 3 fast",
    inputTokenLimit: 480,
    outputTokenLimit: 8192,
    supportedGenerationMethods: ["predictLongRunning"],
  },
  {
    name: "veo-3.1-generate-preview",
    version: "3.1",
    displayName: "Veo 3.1",
    description: "Veo 3.1",
    inputTokenLimit: 480,
    outputTokenLimit: 8192,
    supportedGenerationMethods: ["predictLongRunning"],
  },
  {
    name: "veo-3.1-fast-generate-preview",
    version: "3.1",
    displayName: "Veo 3.1 fast",
    description: "Veo 3.1 fast",
    inputTokenLimit: 480,
    outputTokenLimit: 8192,
    supportedGenerationMethods: ["predictLongRunning"],
  },
  {
    name: "veo-3.1-lite-generate-preview",
    version: "3.1",
    displayName: "Veo 3.1 lite",
    description: "Veo 3.1 lite",
    inputTokenLimit: 480,
    outputTokenLimit: 8192,
    supportedGenerationMethods: ["predictLongRunning"],
  },
];

export const PENDING_INVOICE = 0;

export const INVOICE_STATUS_OBJ = {
  INVOICE_DRAFT_CREATED: "INVOICE_DRAFT_CREATED",
  INVOICE_HAS_CODE_NOT_SENT: "INVOICE_HAS_CODE_NOT_SENT",
  INVOICE_NO_CODE_NOT_SENT: "INVOICE_NO_CODE_NOT_SENT",
  INVOICE_HAS_CODE_SENT: "INVOICE_HAS_CODE_SENT",
  INVOICE_NO_CODE_SENT: "INVOICE_NO_CODE_SENT",
  INVOICE_HAS_CODE_APPROVED: "INVOICE_HAS_CODE_APPROVED",
  INVOICE_NO_CODE_APPROVED: "INVOICE_NO_CODE_APPROVED",
  INVOICE_HAS_CODE_DIS_APPROVED: "INVOICE_HAS_CODE_DIS_APPROVED",
  INVOICE_NO_CODE_DIS_APPROVED: "INVOICE_NO_CODE_DIS_APPROVED",
  // Me invoice
  ME_INVOICE_NOT_SENT: 'ME_INVOICE_NOT_SENT',
  ME_INVOICE_SENT: 'ME_INVOICE_SENT',
  ME_INVOICE_SENT_ACCEPT: 'ME_INVOICE_SENT_ACCEPT',
  ME_INVOICE_SENT_REJECT: 'ME_INVOICE_SENT_REJECT',
  ME_INVOICE_SENT_ERROR: 'ME_INVOICE_SENT_ERROR',
};

export const INVOICE_STATUS_SEND = [
  {
    id: INVOICE_STATUS_OBJ.INVOICE_DRAFT_CREATED,
    label: "Đã tạo HĐ nháp",
    color: "#EF5816",
  },
  {
    id: INVOICE_STATUS_OBJ.INVOICE_HAS_CODE_NOT_SENT,
    label: "Chưa gửi CQT",
    color: "#F31D00",
  },
  {
    id: INVOICE_STATUS_OBJ.INVOICE_NO_CODE_NOT_SENT,
    label: "Chưa gửi CQT",
    color: "#F31D00",
  },
  {
    id: INVOICE_STATUS_OBJ.INVOICE_HAS_CODE_SENT,
    label: "Chờ CQT xác nhận",
    color: "#EF5816",
  },
  {
    id: INVOICE_STATUS_OBJ.INVOICE_NO_CODE_SENT,
    label: "Chờ CQT xác nhận",
    color: "#EF5816",
  },
  {
    id: INVOICE_STATUS_OBJ.INVOICE_HAS_CODE_APPROVED,
    label: "HĐ hợp lệ",
    color: "#219737",
  },
  {
    id: INVOICE_STATUS_OBJ.INVOICE_NO_CODE_APPROVED,
    label: "HĐ hợp lệ",
    color: "#219737",
  },
  {
    id: INVOICE_STATUS_OBJ.INVOICE_HAS_CODE_DIS_APPROVED,
    label: "HĐ không hợp lệ",
    color: "#616161",
  },
  {
    id: INVOICE_STATUS_OBJ.INVOICE_NO_CODE_DIS_APPROVED,
    label: "HĐ không hợp lệ",
    color: "#616161",
  },
  {
    id: INVOICE_STATUS_OBJ.ME_INVOICE_NOT_SENT,
    label: 'Chưa gửi CQT',
    color: '#F31D00',
  },
  {
    id: INVOICE_STATUS_OBJ.ME_INVOICE_SENT,
    label: 'Đã gửi CQT',
    color: '#EF5816',
  },
  {
    id: INVOICE_STATUS_OBJ.ME_INVOICE_SENT_ACCEPT,
    label: 'HĐ hợp lệ',
    color: '#219737',
  },
  {
    id: INVOICE_STATUS_OBJ.ME_INVOICE_SENT_REJECT,
    label: 'HĐ không hợp lệ',
    color: '#616161',
  },
  {
    id: INVOICE_STATUS_OBJ.ME_INVOICE_SENT_ERROR,
    label: 'Gửi CQT lỗi',
    color: '#EF5816',
  },
];

export const INVOICE_STATUS_FILTER = [
  {
    id: INVOICE_STATUS_OBJ.INVOICE_DRAFT_CREATED,
    label: "Đã tạo HĐ nháp",
  },
  {
    id: "CODE_NOT_SENT",
    label: "Chưa gửi CQT",
  },
  {
    id: "CODE_SENT",
    label: "Chờ CQT xác nhận",
  },
  {
    id: "CODE_APPROVED",
    label: "HĐ hợp lệ",
  },
  {
    id: "CODE_DIS_APPROVED",
    label: "HĐ không hợp lệ",
  },
  {
    id: INVOICE_STATUS_OBJ.ME_INVOICE_NOT_SENT,
    label: 'Misa chưa gửi CQT',
    color: '#F31D00',
  },
  {
    id: INVOICE_STATUS_OBJ.ME_INVOICE_SENT,
    label: 'Misa đã gửi CQT',
    color: '#EF5816',
  },
  {
    id: INVOICE_STATUS_OBJ.ME_INVOICE_SENT_ACCEPT,
    label: 'Misa HĐ hợp lệ',
    color: '#219737',
  },
  {
    id: INVOICE_STATUS_OBJ.ME_INVOICE_SENT_REJECT,
    label: 'Misa HĐ không hợp lệ',
    color: '#616161',
  },
  {
    id: INVOICE_STATUS_OBJ.ME_INVOICE_SENT_ERROR,
    label: 'Misa gửi CQT lỗi',
    color: '#EF5816',
  },
];

export const INVOICE_RELEASE = "INVOICE_RELEASE";
export const INVOICE_DRAFT = "INVOICE_DRAFT";
export const INVOICE_TYPE_SETTING = [
  {
    id: INVOICE_RELEASE,
    label: "Trực tiếp",
    textInfo: [
      "Hóa đơn điện tử được phát hành và việc xử lý chữ ký số được thực hiện thông qua ứng dụng Smenubook.",
      "Hình thức này không yêu cầu sự tham gia của bộ phận kế toán.",
    ],
  },
  {
    id: INVOICE_DRAFT,
    label: "Gián tiếp",
    textInfo: [
      "Ứng dụng Smenubook tạo hóa đơn nháp, trong khi việc phát hành và xử lý chữ ký số được đảm nhiệm bởi hệ thống hóa đơn điện tử. ",
      "Hình thức này yêu cầu sự tham gia của bộ phận kế toán.",
    ],
  },
];
export const DEFAULT_INVOICE_BUYER = "Người mua không lấy hóa đơn";
export const LINK_SEARCH =
  "https://vinvoice.viettel.vn/utilities/invoice-search";

export const MISA_TABS = [
  { label: "Thiết lập kết nối", value: 1 },
  { label: "Thiết lập tự động", value: 2 },
  { label: "Đồng bộ danh mục", value: 3 },
  { label: "Đồng bộ bán hàng", value: 4 },
  { label: "Đồng bộ kho", value: 5 },
  { label: "Nhật ký đồng bộ", value: 6 },
];

export const REPORT_TABS = [
  { label: "Báo cáo bán hàng", value: 1 },
  { label: "Báo cáo lãi lỗ", value: 2 },
  { label: "Báo cáo tồn kho", value: 3 },
  { label: "Báo cáo thu chi", value: 4 },
];

// Sync Status enum mapping
export const SYNC_STATUS = {
  PENDING: 0,
  SUCCESS: 1,
  FAILED: 2,
};

export const SYNC_STATUS_OPTIONS = [
  {
    value: -1,
    label: "Tất cả trạng thái",
    color: null,
  },
  {
    value: SYNC_STATUS.PENDING,
    label: "Chờ xử lý",
    color: "#faad14",
  },
  {
    value: SYNC_STATUS.SUCCESS,
    label: "Thành công",
    color: "#52c41a",
  },
  {
    value: SYNC_STATUS.FAILED,
    label: "Thất bại",
    color: "#ff4d4f",
  },
];

export const SYNC_TYPE = {
  UNIT: 1,
  INVENTORY_CATEGORY: 2,
  INVENTORY_ITEM: 3,
  CUSTOMER: 4,
  ORDER: 5,
  MATERIAL: 6,
  MATERIAL_CATEGORY: 7,
  MATERIAL_UNIT: 8,
  STOCK: 9,
  INWARD: 10,
  OUTWARD: 11,
  SUPPLIER: 14,
};

export const SYNC_TYPE_OPTIONS = [
  { value: -1, label: "Tất cả danh mục" },
  { value: SYNC_TYPE.UNIT, label: "Đơn vị tính" },
  { value: SYNC_TYPE.INVENTORY_CATEGORY, label: "Nhóm hàng hóa" },
  { value: SYNC_TYPE.INVENTORY_ITEM, label: "Hàng hóa" },
  { value: SYNC_TYPE.CUSTOMER, label: "Khách hàng" },
  { value: SYNC_TYPE.ORDER, label: "Đơn hàng" },
  { value: SYNC_TYPE.MATERIAL, label: "Nguyên vật liệu" },
  { value: SYNC_TYPE.MATERIAL_CATEGORY, label: "Nhóm nguyên vật liệu" },
  { value: SYNC_TYPE.MATERIAL_UNIT, label: "Đơn vị tính nguyên vật liệu" },
  { value: SYNC_TYPE.STOCK, label: "Kho" },
  { value: SYNC_TYPE.INWARD, label: "Nhập kho" },
  { value: SYNC_TYPE.OUTWARD, label: "Xuất kho" },
];

export const SYNC_CATEGORY = {
  STOCK: 3,
  CATEGORY: 2,
  SALES: 1,
};

export const SYNC_CATEGORY_OPTIONS = [
  { value: -1, label: "Tất cả loại" },
  { value: SYNC_CATEGORY.CATEGORY, label: "Danh mục" },
  { value: SYNC_CATEGORY.SALES, label: "Bán hàng" },
  { value: SYNC_CATEGORY.STOCK, label: "Kho" },
];

export const EApiCredential = {
  Misa: 1,
  Brevo: 2,
};

export const PRODUCT_CATEGORY = {
  PRODUCT_COOKING: 0,
  PRODUCT_WAREHOUSE: 1,
};

export const PRODUCT_CATEGORY_ARRAY = [
  { value: PRODUCT_CATEGORY.PRODUCT_COOKING, label: "Thành phẩm" },
  { value: PRODUCT_CATEGORY.PRODUCT_WAREHOUSE, label: "Hàng hóa" },
];

export const CUSTOMER_CATEGORY = {
  INDIVIDUAL: 1,
  BUSINESS: 2,
};

export const CUSTOMER_CATEGORY_OPTIONS = [
  { value: CUSTOMER_CATEGORY.INDIVIDUAL, label: "Cá nhân" },
  { value: CUSTOMER_CATEGORY.BUSINESS, label: "Doanh nghiệp" },
];

export const CUSTOMER_TYPE = {
  POTENTIAL: 1,
  PURCHASED: 2,
};

export const CUSTOMER_TYPE_OPTIONS = [
  { value: CUSTOMER_TYPE.POTENTIAL, label: "Tiềm năng" },
  { value: CUSTOMER_TYPE.PURCHASED, label: "Đã mua hàng" },
];

export const CUSTOMER_SOURCE_TYPE = {
  BRANCH: 1,
  HQ: 2,
  SELFREGISTERED: 3,
  FROMORDER: 4,
};

export const CUSTOMER_SOURCE_TYPE_OPTIONS = [
  { value: CUSTOMER_SOURCE_TYPE.BRANCH, label: "Chi nhánh tạo" },
  { value: CUSTOMER_SOURCE_TYPE.HQ, label: "Tổng công ty tạo" },
  { value: CUSTOMER_SOURCE_TYPE.SELFREGISTERED, label: "Khách tự đăng ký" },
  { value: CUSTOMER_SOURCE_TYPE.FROMORDER, label: "Phát sinh qua đơn hàng" },
];

export const CUSTOMER_GENDER = [
  { name: "Chưa xác định", id: 0 },
  { name: "Nam", id: 1 },
  { name: "Nữ", id: 2 },
];

export const SEMI_PRODUCT_STATUS = {
  InUse: true,
  UnUse: false,
};
export const SEMI_PRODUCT_STATUS_FILTER = [
  { value: SEMI_PRODUCT_STATUS.InUse, label: "Đang sử dụng", color: "#219737" },
  { value: SEMI_PRODUCT_STATUS.UnUse, label: "Ngừng sử dụng", color: "#505D6E" },
];

export const WAREHOUSE_QUANTITY_STATUS = {
  ALL: 0,
  HAS_MANY: 1,
  EMPTY: 2,
  LOW: 3,
};

export const PRODUCT_STATUS_FILTER = [
  {
    id: "all",
    value: WAREHOUSE_QUANTITY_STATUS.ALL,
    title: "Trạng thái",
  },
  {
    id: "hasItem",
    value: WAREHOUSE_QUANTITY_STATUS.HAS_MANY,
    title: "Còn hàng",
  },
  {
    id: "emptyItem",
    value: WAREHOUSE_QUANTITY_STATUS.EMPTY,
    title: "Hết hàng",
  },
  {
    id: "threshold",
    value: WAREHOUSE_QUANTITY_STATUS.LOW,
    title: "Tồn kho thấp",
  },
];

export const SORT_ORDER = {
  TIME_DESC: "time_desc",
  NAME_ASC: "name_asc",
  NAME_DSC: "name_dsc",
  NUMBER_ASC: "number_asc",
  NUMBER_DSC: "number_dsc",
  BY_QUANTITY: "by_quantity",
};

export const SORT_BY_ORDER = [
  {
    id: "by_time_desc",
    value: SORT_ORDER.TIME_DESC,
    title: "Theo thời gian tạo",
  },
  {
    id: "by_name_asc",
    value: SORT_ORDER.NAME_ASC,
    title: "Theo tên từ A -> Z",
  },
  {
    id: "by_name_dsc",
    value: SORT_ORDER.NAME_DSC,
    title: "Theo tên từ Z -> A",
  },
  {
    id: "by_number_asc",
    value: SORT_ORDER.NUMBER_ASC,
    title: "Số lượng từ ít -> nhiều",
  },
  {
    id: "by_number_dsc",
    value: SORT_ORDER.NUMBER_DSC,
    title: "Số lượng từ nhiều -> ít",
  },
  {
    id: "by_quantity",
    value: SORT_ORDER.BY_QUANTITY,
    title: "Giá trị tồn từ cao -> thấp",
  },
];

export const IMPORT_STATUS = {
  TEMPORARY: 0,
  IMPORTED: 1,
  CANCELED: 2,
};

export const IMPORT_STATUS_VIEW = [
  { value: IMPORT_STATUS.TEMPORARY, label: "Bản nháp", color: "#3A70EE", bg: "#E8F0FF" },
  { value: IMPORT_STATUS.IMPORTED, label: "Đã nhập", color: "#13BE4C", bg: "#E3F8EA" },
  { value: IMPORT_STATUS.CANCELED, label: "Đã hủy", color: "#F31D00", bg: "#FFE8E5" },
];

export const IMPORT_STATUS_FILTER = [
  {
    id: "all",
    value: -1,
    title: "Tất cả trạng thái",
  },
  {
    id: "imported",
    value: IMPORT_STATUS.IMPORTED,
    title: "Đã nhập",
  },
  {
    id: "canceled",
    value: IMPORT_STATUS.CANCELED,
    title: "Đã hủy",
  },
];

export const IMPORT_PRICE = {
  ALL: "all",
  LESS_2M: "less2M",
  FROM_2_TO_10: "from2to10",
  GREATER_10: "greater10",
};

export const IMPORT_PRICE_FILTER = [
  {
    id: "all",
    value: IMPORT_PRICE.ALL,
    title: "Tất cả giá trị",
  },
  {
    id: "less2M",
    value: IMPORT_PRICE.LESS_2M,
    title: "< 2.000.000đ",
  },
  {
    id: "from2to10",
    value: IMPORT_PRICE.FROM_2_TO_10,
    title: "2.000.000đ - 10.000.000đ",
  },
  {
    id: "greater10",
    value: IMPORT_PRICE.GREATER_10,
    title: "> 10.000.000đ",
  },
];

export const orderStatus = {
  Init: 0,
  Confirmed: 1,
  Cooking: 2,
  Completed: 3,
  PaymentRequest: 4,
  Paid: 5,
  CanceledByUser: 6,
  CanceledByAdmin: 7,
};

export const ORDER_STATUS_LIST = [
  { id: orderStatus.Init, label: "Chưa chế biến", color: "" },
  { id: orderStatus.Confirmed, label: "Đã xác nhận đơn", color: "#F31D00" },
  { id: orderStatus.Cooking, label: "Đang chế biến", color: "#F31D00" },
  { id: orderStatus.Completed, label: "Đã xong", color: "#F31D00" },
  {
    id: orderStatus.PaymentRequest,
    label: "Yêu cầu thanh toán",
    color: "#F31D00",
  },
  { id: orderStatus.Paid, label: "Đã thanh toán", color: "#219737" },
  { id: orderStatus.CanceledByUser, label: "Hủy bởi khách hàng", color: "" },
  { id: orderStatus.CanceledByAdmin, label: "Hủy bởi nhân viên", color: "" },
];

export const ORDER_STATUS_FILTER = [
  {
    id: "all",
    value: -1,
    title: "Tất cả trạng thái",
  },
  {
    id: "imported",
    value: orderStatus.Paid,
    title: "Đã thanh toán",
  },
  {
    id: "canceled",
    value: orderStatus.CanceledByAdmin,
    title: "Đã hủy",
  },
];

export const TRANSFER_STATUS = {
  TEMPORARY: 0,
  NOT_CONFIRMED: 1,
  CONFIRMED: 2,
  REJECTED: 3,
  CANCELED: 4,
};

export const TRANSFER_STATUS_FILTER = [
  {
    value: TRANSFER_STATUS.TEMPORARY,
    label: "Bản nháp",
    color: "#3A70EE",
    bg: "#EAF0FF",
  },
  {
    value: TRANSFER_STATUS.NOT_CONFIRMED,
    label: "Chờ xác nhận",
    color: "#EF5816",
    bg: "#FFF1EB",
  },
  {
    value: TRANSFER_STATUS.CONFIRMED,
    label: "Đã chuyển kho",
    color: "#219737",
    bg: "#EAF7EC",
  },
  {
    value: TRANSFER_STATUS.REJECTED,
    label: "Đã từ chối",
    color: "#EF5816",
    bg: "#FFF1EB",
  },
  {
    value: TRANSFER_STATUS.CANCELED,
    label: "Đã hủy",
    color: "#EF5816",
    bg: "#FFF1EB",
  },
];

export const TRANSFER_OUT_STATUS = [
  {
    id: "all",
    value: -1,
    title: "Tất cả trạng thái",
  },
  {
    id: "not_confirmed",
    value: TRANSFER_STATUS.NOT_CONFIRMED,
    title: "Chờ xác nhận",
  },
  {
    id: "confirmed",
    value: TRANSFER_STATUS.CONFIRMED,
    title: "Đã xác nhận",
  },
  {
    id: "rejected",
    value: TRANSFER_STATUS.REJECTED,
    title: "Đã từ chối",
  },
  {
    id: "canceled",
    value: TRANSFER_STATUS.CANCELED,
    title: "Đã hủy",
  },
];

export const WAREHOUSE_ORDER_STATUS = [
  { value: 5, label: "Đã thanh toán", color: "#219737" },
  { value: 7, label: "Đã hủy", color: "#EF5816" },
];

export const WAREHOUSE_CHECK_STATUS = {
  CHECKING: 0,
  CHECKED: 1,
  BALANCED: 2,
  CANCELED: 3,
};

export const WAREHOUSE_CHECK_STATUS_VIEW = [
  {
    value: WAREHOUSE_CHECK_STATUS.CHECKING,
    label: "Đang kiểm kho",
    color: "#EF5816",
    bg: "#FFF0E9",
  },
  {
    value: WAREHOUSE_CHECK_STATUS.CHECKED,
    label: "Kiểm kho xong",
    color: "#3A70EE",
    bg: "#EDF2FF",
  },
  {
    value: WAREHOUSE_CHECK_STATUS.BALANCED,
    label: "Đã cân bằng",
    color: "#219737",
    bg: "#EAF7ED",
  },
  {
    value: WAREHOUSE_CHECK_STATUS.CANCELED,
    label: "Đã hủy",
    color: "#F31D00",
    bg: "#FFEBE8",
  },
];

export const EXCHANGE_OPERATOR = {
  MULTIPLE: 0,
  DIVISION: 1,
};

export const SupplierType = [
  { value: 1, label: "Doanh nghiệp nhà nước", shortName: "DNNN" },
  { value: 2, label: "Doanh nghiệp tư nhân", shortName: "DNTN" },
  { value: 3, label: "Cá thể & hộ kinh doanh", shortName: "HKD" },
];

export const REPORT_TYPE = {
  // Doanh thu và bán hàng
  ORDER: 1,
  PRODUCT: 2,
  EMPLOYEE: 3,

  // Khách hàng và vận hành
  CUSTOMER: 4,
  PROMOTION: 5,
  TREND: 6,

  // Tài chính và kế toán
  PROFIT_LOSS: 7,
  PAYMENT_CASH_FLOW: 8,
  CASHBOOK_DEBT: 9,
  INVOICE: 10,

  // Kho và kiểm soát
  INVENTORY_OVERVIEW: 11,
  INVENTORY_LOSS: 12,
  ORDER_RISK_CONTROL: 13,
  SUPPLIER: 14,
  WAREHOUSE_SUMMARY: 15,
};

export const REPORT_TYPE_REVENUE = {
  ORDER: 1,
  PRODUCT: 2,
  EMPLOYEE: 3,
};

export const REPORT_OPTIONS_REVENUE = [
  {
    label: "Báo cáo đơn hàng",
    value: REPORT_TYPE_REVENUE.ORDER,
  },
  {
    label: "Hiệu suất sản phẩm",
    value: REPORT_TYPE_REVENUE.PRODUCT,
  },
  {
    label: "Hiệu suất nhân viên",
    value: REPORT_TYPE_REVENUE.EMPLOYEE,
  },
];

export const REPORT_TYPE_CUSTOMER = {
  CUSTOMER: 4,
  PROMOTION: 5,
  TREND: 6,
};

export const REPORT_OPTIONS_CUSTOMER = [
  {
    label: "Tổng quan khách hàng",
    value: REPORT_TYPE_CUSTOMER.CUSTOMER,
  },
  {
    label: "Hiệu quả khuyến mãi",
    value: REPORT_TYPE_CUSTOMER.PROMOTION,
  },
  {
    label: "Báo cáo xu hướng",
    value: REPORT_TYPE_CUSTOMER.TREND,
  },
];

export const REPORT_TYPE_ACCOUNTING = {
  PAYMENT_CASH_FLOW: 8,
  CASHBOOK_DEBT: 9,
  INVOICE: 10,
};

export const REPORT_OPTIONS_ACCOUNTING = [
  {
    label: "Hiệu quả kinh doanh P&L",
    value: REPORT_TYPE.PROFIT_LOSS,
  },
  {
    label: "Dòng tiền thanh toán",
    value: REPORT_TYPE_ACCOUNTING.PAYMENT_CASH_FLOW,
  },
  {
    label: "Thu chi và công nợ",
    value: REPORT_TYPE_ACCOUNTING.CASHBOOK_DEBT,
  },
  {
    label: "Bảng kê hóa đơn",
    value: REPORT_TYPE_ACCOUNTING.INVOICE,
  },
];

export const REPORT_TYPE_CONTROL = {
  INVENTORY_OVERVIEW: 11,
  INVENTORY_LOSS: 12,
  ORDER_RISK_CONTROL: 13,
  SUPPLIER: 14,
  WAREHOUSE_SUMMARY: 15,
};

export const REPORT_OPTIONS_CONTROL = [
  {
    label: "Tổng hợp tồn kho",
    value: REPORT_TYPE_CONTROL.WAREHOUSE_SUMMARY,
  },
  {
    label: "Chi tiết nhập xuất kho",
    value: REPORT_TYPE_CONTROL.INVENTORY_OVERVIEW,
  },
  {
    label: "Kiểm soát hao hụt kho",
    value: REPORT_TYPE_CONTROL.INVENTORY_LOSS,
  },
  {
    label: "Kiểm soát rủi ro & gian lận",
    value: REPORT_TYPE_CONTROL.ORDER_RISK_CONTROL,
  },
  // {
  //   label: "Báo cáo nhà cung cấp",
  //   value: REPORT_TYPE_CONTROL.SUPPLIER,
  // },
];

export const PAYMENT_METHOD_OPTIONS = [
  { label: "Tiền mặt", value: 0 },
  { label: "Chuyển khoản", value: 1 },
  { label: "Grabpay", value: 2 },
  { label: "Shopeepay", value: 3 },
  { label: "XanhSM", value: 4 },
  { label: "Khác", value: 5 },
  { label: "Vnpay", value: 6 },
  { label: "Galaxy Pay", value: 7 },
];

export const ORDER_STATUS_OPTIONS = [
  { label: "Tạo mới", value: 0 },
  { label: "Đã xác nhận", value: 1 },
  { label: "Đang chế biến", value: 2 },
  { label: "Đã xong", value: 3 },
  { label: "Yêu cầu thanh toán", value: 4 },
  { label: "Đã thanh toán", value: 5 },
  { label: "Huỷ bởi người dùng", value: 6 },
  { label: "Huỷ bởi quản lý", value: 7 },
];

export const PRODUCT_STATUS_OPTIONS = [
  { label: "Ngừng kinh doanh", value: 0 },
  { label: "Đang kinh doanh", value: 1 },
];

export const SORT_REVENUE_OPTIONS = [
  { label: "Doanh thu tăng dần", value: 1 },
  { label: "Doanh thu giảm dần", value: 2 },
];

export const PROMOTION_TYPE_OPTIONS = [
  { label: "Voucher", value: 1 },
  { label: "Tích điểm", value: 2 },
  { label: "Chiết khấu", value: 3 },
];

export const INVENTORY_TYPE_OPTIONS = [
  { label: "Nhập kho", value: 1 },
  { label: "Xuất bán hàng", value: 2 },
  { label: "Nhập chuyển kho", value: 3 },
  { label: "Xuất chuyển kho", value: 4 },
  { label: "Xuất trả lại", value: 5 },
  { label: "Xuất huỷ", value: 6 },
  { label: "Xuất khác", value: 7 },
];

export const INVENTORY_CATEGORY_OPTIONS = [
  { label: "Nguyên vật liệu", value: 1 },
  { label: "Hàng hóa", value: 2 },
  { label: "Công cụ dụng cụ", value: 3 },
];

export const RISK_CONTROL_TYPE_OPTIONS = [
  { label: "Huỷ đơn", value: 1 },
  { label: "Huỷ món", value: 2 },
  { label: "Giảm món", value: 3 },
  { label: "Thay đổi KM", value: 4 },
];

export const SUPPLIER_GROUP_OPTIONS = [
  { label: "Nguyên vật liệu", value: 1 },
  { label: "Sản phẩm", value: 2 },
  { label: "Sản phẩm & NVL", value: 3 },
];

export const PAYMENT_CASH_FLOW_SOURCE_OPTIONS = [
  { label: "Tiền mặt", value: 0 },
  { label: "Ví điện tử", value: 1 },
  { label: "Ngân hàng", value: 2 },
  { label: "Khác", value: 3 },
];

export const CASHBOOK_DEBT_TYPE_OPTIONS = [
  { label: "Khoản thu", value: 0 },
  { label: "Khoản chi", value: 1 },
];

export const INVOICE_STATUS_OPTIONS = [
  { label: "Đã phát hành", value: 1 },
  { label: "Nháp", value: 2 },
];

export const PROFIT_LOSS_SORT_OPTIONS = [
  { label: "Lợi nhuận ròng tăng dần", value: 1 },
  { label: "Lợi nhuận ròng giảm dần", value: 2 },
];

export const INVOICE_CODE_FILTER = [
  {
    id: 1,
    value: null,
    title: "Tất cả phiếu",
  },
  {
    id: 2,
    value: true,
    title: "Phiếu có hóa đơn",
  },
  {
    id: 3,
    value: false,
    title: "Phiếu không có hóa đơn",
  },
];

export const REQUEST_ORDER_STATUS = {
  DRAFT: 0,
  WAITING_BRANCH_APPROVAL: 1,
  WAITING_PURCHASING_APPROVAL: 2,
  REJECTED: 3,
  APPROVED: 4,
  PROCESSING: 5,
  COMPLETED: 6,
  CANCELED: 7,
};

export const REQUEST_ORDER_STATUS_VIEW = [
  {
    value: REQUEST_ORDER_STATUS.DRAFT,
    label: "Nháp",
    color: "#374151",
    background: "#F3F4F6",
  },
  {
    value: REQUEST_ORDER_STATUS.WAITING_BRANCH_APPROVAL,
    label: "Chờ duyệt CN",
    color: "#D97706",
    background: "#FEF3C7",
  },
  {
    value: REQUEST_ORDER_STATUS.WAITING_PURCHASING_APPROVAL,
    label: "Chờ duyệt BPMH",
    color: "#D97706",
    background: "#FEF3C7",
  },
  {
    value: REQUEST_ORDER_STATUS.REJECTED,
    label: "Bị từ chối",
    color: "#DC2626",
    background: "#FEE2E2",
  },
  {
    value: REQUEST_ORDER_STATUS.APPROVED,
    label: "Đã duyệt",
    color: "#0284C7",
    background: "#E0F2FE",
  },
  {
    value: REQUEST_ORDER_STATUS.PROCESSING,
    label: "Đang xử lý",
    color: "#4338CA",
    background: "#E0E7FF",
  },
  {
    value: REQUEST_ORDER_STATUS.COMPLETED,
    label: "Hoàn thành",
    color: "#16A34A",
    background: "#DCFCE7",
  },
  {
    value: REQUEST_ORDER_STATUS.CANCELED,
    label: "Đã hủy",
    color: "#6B7280",
    background: "#F3F4F6",
  },
];

export const REQUEST_ORDER_STATUS_FILTER = [
  ...REQUEST_ORDER_STATUS_VIEW.map((item) => ({
    id: item.value,
    value: item.value,
    title: item.label,
  })),
];

export const REQUEST_ORDER_ITEM_TYPE = {
  MATERIAL: 1,
  PRODUCT_VARIANT: 2,
};

export const PURCHASE_ORDER_STATUS_VIEW = [
  { value: 0, label: "Mới tạo", color: "#374151", background: "#F3F4F6" },
  { value: 1, label: "Đang mua", color: "#D97706", background: "#FEF3C7" },
  {
    value: 2,
    label: "Đã nhận 1 phần",
    color: "#0284C7",
    background: "#E0F2FE",
  },
  { value: 3, label: "Hoàn thành", color: "#16A34A", background: "#DCFCE7" },
  { value: 4, label: "Đóng thiếu", color: "#DC2626", background: "#FEE2E2" },
];

export const PURCHASE_ORDER_STATUS = {
  NEW: 0,
  PURCHASING: 1,
  PARTIALLY_RECEIVED: 2,
  COMPLETED: 3,
  CLOSED_SHORT: 4,
};

export const PURCHASE_ORDER_STATUS_FILTER = [
  ...PURCHASE_ORDER_STATUS_VIEW.map((item) => ({
    id: item.value,
    value: item.value,
    title: item.label,
  })),
];

export const PURCHASE_PAYMENT_STATUS = {
  UNPAID: 0,
  PAID: 1,
};

export const ITEM_TYPE_FILTERS = [
  { label: "Tất cả", value: null },
  { label: "Sản phẩm", value: REQUEST_ORDER_ITEM_TYPE.PRODUCT_VARIANT },
  { label: "Nguyên vật liệu", value: REQUEST_ORDER_ITEM_TYPE.MATERIAL },
];

export const SUPPLIER_STATUS = {
  ACTIVE: 1,
  INACTIVE: 2,
};

export const SUPPLIER_STATUS_FILTER = [
  { label: "Trạng thái", value: null },
  {
    label: "Đang cung ứng",
    value: SUPPLIER_STATUS.ACTIVE,
    color: "#16A34A",
    background: "#DCFCE7",
  },
  {
    label: "Ngừng cung ứng",
    value: SUPPLIER_STATUS.INACTIVE,
    color: "#DC2626",
    background: "#FEE2E2",
  },
];

export const TRANSFER_STATUS_VIEW = {
  0: { color: "#374151", background: "#F3F4F6" }, 
  1: { color: "#D97706", background: "#FEF3C7" }, 
  2: { color: "#16A34A", background: "#DCFCE7" }, 
  3: { color: "#DC2626", background: "#FEE2E2" },
  4: { color: "#6B7280", background: "#F3F4F6" },
};

export const WORKSPACES = {
  COMPANY: "company",
  PURCHASING: "purchasing",
  BRANCH: "branch",
}

export const WORKSPACE_OPTION = [
  {
    value: WORKSPACES.BRANCH,
    label: "Chi nhánh",
  },
  {
    value: WORKSPACES.PURCHASING,
    label: "Bộ phận mua hàng",
  },
  {
    value: WORKSPACES.COMPANY,
    label: "Tổng công ty",
  },
]

export const VOUCHER_REWARD_TYPE = {
  BY_DISCOUNT_ORDER: 0,
  BY_PAYMENT_METHOD: 1,
};

export const VOUCHER_REWARD_SETTING = [
  {
    id: VOUCHER_REWARD_TYPE.BY_DISCOUNT_ORDER,
    label: "Hạch toán vào giảm trừ doanh thu",
    description: "Giảm trực tiếp vào tổng tiền (xuất hóa đơn chuẩn)",
  },
  {
    id: VOUCHER_REWARD_TYPE.BY_PAYMENT_METHOD,
    label: "Hạch toán như phương thức thanh toán",
    description: "Ghi nhận như khách đã thanh toán một phần",
  },
];

export const INVENTORY_ITEM_TYPE = {
  MATERIAL: 1,
  PRODUCT_VARIANT: 2,
};

export const INVENTORY_DIRECTION = {
  ALL: 0,
  IMPORT: 1,
  EXPORT: 2,
  ADJUST: 3,
};

export const INVENTORY_DIRECTION_FILTER = [
  { id: 1, value: INVENTORY_DIRECTION.ALL, title: "Tất cả" },
  { id: 2, value: INVENTORY_DIRECTION.IMPORT, title: "Nhập" },
  { id: 3, value: INVENTORY_DIRECTION.EXPORT, title: "Xuất" },
  { id: 4, value: INVENTORY_DIRECTION.ADJUST, title: "Điều chỉnh" },
];

const INVENTORY_TAG_IMPORT = { background: "#E7F6EC", color: "#15803D" };
const INVENTORY_TAG_EXPORT = { background: "#FDECEC", color: "#D92D20" };
const INVENTORY_TAG_ADJUST = { background: "#FEF3C7", color: "#B45309" };
const INVENTORY_TAG_OPENING = { background: "#E8F0FE", color: "#2F6FED" };

export const INVENTORY_TRANSACTION_TYPE_STYLE = {
  1: INVENTORY_TAG_OPENING, // Số dư đầu kỳ
  10: INVENTORY_TAG_IMPORT, // Mua hàng
  11: INVENTORY_TAG_IMPORT, // Chuyển kho đến
  12: INVENTORY_TAG_IMPORT, // Hoàn kho
  13: INVENTORY_TAG_IMPORT, // Nhập khác
  20: INVENTORY_TAG_EXPORT, // Xuất bán
  21: INVENTORY_TAG_EXPORT, // Xuất chế biến
  22: INVENTORY_TAG_EXPORT, // Chuyển kho đi
  23: INVENTORY_TAG_EXPORT, // Xuất trả lại
  24: INVENTORY_TAG_EXPORT, // Xuất khác
  25: INVENTORY_TAG_EXPORT, // Xuất huỷ
  30: INVENTORY_TAG_ADJUST, // Điều chỉnh kiểm kho
};

export const INVENTORY_DOCUMENT_ROUTES = {
  1: null, // Phiếu nhập
  2: null, // Phiếu xuất
  3: null, // Phiếu chuyển kho
  4: null, // Phiếu kiểm kho
  5: null, // Đơn hàng
};

export const PRICELIST_STATUS = {
  ACTIVE: 1,
  INACTIVE: 0,
};

export const PRICELIST_STATUS_OPTION = [
  { value: PRICELIST_STATUS.ACTIVE, label: "Đang dùng", color: "#138A45", background: "#EAF8EF" },
  { value: PRICELIST_STATUS.INACTIVE, label: "Ngừng dùng", color: "#D43842", background: "#FFF0F0" ,}
]